/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationCalculateCostSavings {
    getFixupPrototypeFunction() { return ScheduleRecommendationCalculateCostSavings.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationCalculateCostSavings>): ScheduleRecommendationCalculateCostSavings {
        let obj = Object.assign(new ScheduleRecommendationCalculateCostSavings(), model);
        ScheduleRecommendationCalculateCostSavings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationCalculateCostSavings>): ScheduleRecommendationCalculateCostSavings {
        if (!model) return null;
        return ScheduleRecommendationCalculateCostSavings.newInstance(<ScheduleRecommendationCalculateCostSavings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationCalculateCostSavings) {
        if (!obj) return;

        models.ScheduleRecommendationCalculateCostSavings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationCalculateCostSavings): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationCalculateCostSavings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account Ids
     */
    service_account_ids: Array<string>;

}
